import React,{useEffect,useRef,useState} from 'react';
import {FiFilm} from 'react-icons/fi';
const previews=new Map();

// Generate only visible thumbnails and retain small stills for this page session.
export default function MediaThumbnail({row,getUrl}) {
  const key=row.media_path,host=useRef(null),urlGetter=useRef(getUrl);
  urlGetter.current=getUrl;
  const [image,setImage]=useState(()=>previews.get(key));
  useEffect(()=>{
    setImage(previews.get(key));
    if(!row.media_ready || previews.has(key))return;
    let cancelled=false,started=false,video,timer;
    const release=()=>{clearTimeout(timer);if(video){video.onloadedmetadata=null;video.onseeked=null;video.onerror=null;video.removeAttribute('src');video.load();video=null;}};
    const start=async()=>{
      if(started)return;started=true;
      try {
        const url=await urlGetter.current(row);if(cancelled)return;
        video=document.createElement('video');video.crossOrigin='anonymous';video.muted=true;video.preload='metadata';
        video.onloadedmetadata=()=>{video.currentTime=Math.min(.15,Math.max(0,(video.duration || 1)/2));};
        video.onseeked=()=>{if(cancelled || !video)return;try{const canvas=document.createElement('canvas');canvas.width=256;canvas.height=144;const ctx=canvas.getContext('2d');ctx.fillStyle='#202521';ctx.fillRect(0,0,256,144);const scale=Math.min(256/video.videoWidth,144/video.videoHeight);const w=video.videoWidth*scale,h=video.videoHeight*scale;ctx.drawImage(video,(256-w)/2,(144-h)/2,w,h);const still=canvas.toDataURL('image/jpeg',.7);if(previews.size>=100)previews.delete(previews.keys().next().value);previews.set(key,still);setImage(still);}catch{/* Show file icon if the browser cannot decode a frame. */}release();};
        video.onerror=release;timer=setTimeout(release,15000);video.src=url;
      }catch{/* Thumbnail failure must not block opening the file. */}
    };
    const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();void start();}});
    observer.observe(host.current);
    return()=>{cancelled=true;observer.disconnect();release();};
  },[key,row.media_ready]);
  return <span ref={host} className="file-tile-thumbnail" aria-hidden="true">{image?<img src={image} alt=""/>:<FiFilm/>}</span>;
}
